<template>
  <div id="adminContainer">
    <div class="inner">
      <h2>배치 관리</h2>
      <div style="margin-top: 30px; font-weight: 500; font-size: 15px;">
        <div style="margin-bottom: 10px;">예약 관리</div>
        <table cellpadding="0" cellspacing="0" style="min-width: 1350px; border-collapse: collapse;">
          <caption>
            이 표는 구성되어 있습니다.
          </caption>
          <tbody>
            <tr class="top">
              <td style="border-radius: 8px 0 0 8px">구분</td>
              <td>
                시작시간
              </td>
              <td>
                종료시간
              </td>
              <td>
                상태
              </td>
            </tr>
            <!-- 배치 결과 -->
             <tr>
              <td>HR 정보 수신</td>
              <td>{{ videoSchedulerData.startTime | dateFormat }}</td>
              <td>{{ videoSchedulerData.endTime | dateFormat }}</td>
              <td>{{ videoSchedulerData.isSuccess ? '성공' : '실패'}}</td>
            </tr>
            
          </tbody>
        </table>
      </div>

      <div style="margin-top: 80px; margin-bottom: 10px; font-weight: 500; font-size: 15px;">
        <div style="margin-bottom: 10px;">회의록</div>
        <table cellpadding="0" cellspacing="0" style="min-width: 1350px; border-collapse: collapse;">
          <caption>
            이 표는 구성되어 있습니다.
          </caption>
          <tbody>
            <tr class="top">
              <td style="border-radius: 8px 0 0 8px">구분</td>
              <td>
                시작시간
              </td>
              <td>
                종료시간
              </td>
              <td>
                상태
              </td>
            </tr>
            <!-- 배치 결과 -->
             <tr>
              <td>HR 정보 수신</td>
              <td>{{ sttSchedulerData.startTime | dateFormat }}</td>
              <td>{{ sttSchedulerData.endTime | dateFormat }}</td>
              <td>{{ sttSchedulerData.isSuccess ? '성공' : '실패'}}</td>
            </tr>
            
          </tbody>
        </table>
      </div>
      
      <div style="margin-top: 50px; margin-bottom: 10px; font-weight: 500; font-size: 15px;">
        <div style="margin-bottom: 10px;">동시 접속 제한</div>
        <input type="number" style="border-radius: 5px; height: 40px;" v-model="accessUserCount">
        <button class="btnPrimary" style="height: 35px;" @click="updateAccessUser">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/util';
import moment from 'moment';

export default {
  filters: {
    dateFormat: function (day) {
      return moment(day).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data: () => ({
    accessUserCount: 100,
    openStatus: 'beta',
    videoSchedulerData: {
      startTime: null,
      endTime: null,
      isSuccess: false,
    },
    sttSchedulerData: {
      startTime: null,
      endTime: null,
      isSuccess: false,
    }
  }),
  watch: {
    // openStatus (status) {
    //   this.updateOpenStatus(status);
    // },
  },
  async activated () {
    if (!Util.hasSession(this)) return;
    this.init();
  },
  methods: {
    async init () {
      this.$http.get(`/api/v1/systems/accessUserCount`, {})
      .then((ret) => {
          this.accessUserCount = ret.data.accessUserCount;
        });

      this.$http
        .get(`/api/v1/systems/isUpdateOrganization`, { })
        .then((response) => {
          this.videoSchedulerData = response.data.video;
          this.sttSchedulerData = response.data.stt;
          console.log(this.schedulerData);
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

    },
    async updateAccessUser () {
      let json = { accessUserCount: this.accessUserCount };
      this.$http.post(`/api/v1/systems/updateAccessUser`, json)
      .then((ret) => {
          if (ret.data.data === 'success') {
            alert('상태 변경 완료');
          }
        });
    }
    
  }
};
</script>
<style scoped>
.top {
  background: #dfebfe;
  height: 47px;
  font-size: 15px;
  font-weight: 300;
  color: #111;
  padding-left: 10px;
}

td {
  height: 50px;
  font-size: 14px;
  font-weight: 300;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/sections/ManageSystem.vue